import React, { useState } from 'react';
import './EnrollForm.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function EnrollForm({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [mode, setMode] = useState('Hybrid');
  const [formData, setFormData] = useState({
    childName: '', phone: '', email: '', school: '',
    grade: '', phase: '', questions: '', source: '', customSource: '',
    customSchool: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.childName) newErrors.childName = "Child's name is required";
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.school) newErrors.school = 'School name is required';
    if (!formData.grade) newErrors.grade = 'Grade is required';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
  setErrors(newErrors);
  setTimeout(() => {
    const firstError = document.querySelector('.error-field');
    if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 100);
  return;
}

    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType: 'online-stem-enroll',
          childName: formData.childName,
          phone: formData.phone,
          email: formData.email,
          institution: formData.school,
          grade: formData.grade,
          phase: formData.phase,
          mode: mode,
          questions: formData.questions,
          source: formData.source === 'Other' ? formData.customSource : formData.source,
        }),
      });
      try {
        await fetch('http://localhost:5000/api/centre', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name:        formData.childName,
            type:        'School',
            phone:       formData.phone,
            email:       formData.email,
            institution: formData.school === 'other' ? formData.customSchool : formData.school,
            grade:       formData.grade,
            mode:        mode,
            formType:    'Innovators Programme',
            phase:       formData.phase,
            questions:   formData.questions,
            source:      formData.source === 'Other' ? formData.customSource : formData.source,
          }),
        });
      } catch (err) {
        console.log('Dashboard error:', err);
      }

      setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="enroll__overlay" onClick={onClose}>
        <div className="enroll__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your enrollment request for the Online STEM Programme. Our team will get in touch with you within <strong>24 hours</strong> to confirm your enrolment and next steps.</p>
          <button className="enroll__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="enroll__overlay" onClick={onClose}>
      <div className="enroll__box" onClick={(e) => e.stopPropagation()}>

        <button className="enroll__close" onClick={onClose}>✕</button>
        <h2 className="enroll__title">Online STEM Programme — Enrollment Form</h2>

        <div className="enroll__section">
          <label className="enroll__label">Select Programme Mode *</label>
          <div className="enroll__modes">
            <div className={`enroll__mode-card ${mode === 'Hybrid' ? 'enroll__mode-card--active' : ''}`} onClick={() => setMode('Hybrid')}>
              <p className="enroll__mode-title">Hybrid</p>
              <p className="enroll__mode-sub">Online sessions + kit at home</p>
              <p className="enroll__mode-desc">Students attend live online sessions. Kits can be sent home if needed. Contact us for kit details.</p>
            </div>
            <div className={`enroll__mode-card ${mode === 'Offline' ? 'enroll__mode-card--active' : ''}`} onClick={() => setMode('Offline')}>
              <p className="enroll__mode-title">Offline</p>
              <p className="enroll__mode-sub">ibots centre · In-person</p>
              <p className="enroll__mode-desc">Attend all sessions in person at your nearest ibots centre. All kits and tools are provided at the centre during each session.</p>
            </div>
          </div>
        </div>

        <div className="enroll__form">
          <div className="enroll__row">
            <div className="enroll__group">
              <label className="enroll__label">Child's Full Name *</label>
              <input type="text" name="childName" value={formData.childName}
                onChange={handleChange} placeholder="Enter child's name" className="enroll__input" />
              {errors.childName && <p style={errStyle} className="error-field">{errors.childName}</p>}
            </div>
            <div className="enroll__group">
              <label className="enroll__label">Parent's Phone *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="enroll__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
          </div>

          <div className="enroll__row">
            <div className="enroll__group">
              <label className="enroll__label">Email Address</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="you@example.com" className="enroll__input" />
              {errors.email && <p style={errStyle} className="error-field">{errors.email}</p>}
            </div>
            <div className="enroll__group">
              <label className="enroll__label">School Name *</label>
              <select name="school" value={formData.school}
  onChange={handleChange} className="enroll__input enroll__select">
  <option value="">Select school...</option>
  <option value="psg">PSG Public School, Coimbatore</option>
  <option value="nsn">NSN Memorial Senior Secondary School, Coimbatore</option>
  <option value="sboa">SBOA School & Junior College, Coimbatore</option>
  <option value="srikrishna">Sri Krishna International School, Coimbatore</option>
  <option value="pkr">P.K.R. Jain Higher Secondary School, Coimbatore</option>
  <option value="camford">The Camford International School, Coimbatore</option>
  <option value="stanes">Stanes Anglo Indian Higher Secondary School, Coimbatore</option>
  <option value="grd">GRD Matric Higher Secondary School, Coimbatore</option>
  <option value="suguna">Suguna Rippon Matriculation Higher Secondary School, Coimbatore</option>
  <option value="karpagam">Karpagam Matriculation Higher Secondary School, Coimbatore</option>
  <option value="ramakrishna">Sri Ramakrishna Vidyalaya Matriculation Higher Secondary School, Coimbatore</option>
  <option value="vidyavikas">Vidya Vikas Matriculation Higher Secondary School, Coimbatore</option>
  <option value="goodshepherd">Good Shepherd International School, Coimbatore</option>
  <option value="ssvm">SSVM World School, Coimbatore</option>
  <option value="bishopcotton">Bishop Cotton Girls Higher Secondary School, Coimbatore</option>
  <option value="other">Other School</option>
</select>
{formData.school === 'other' && (
  <input type="text" name="customSchool" value={formData.customSchool || ''}
    onChange={handleChange} placeholder="Type your school name..."
    className="enroll__input" style={{ marginTop: '8px' }} />
)}
{errors.school && <p style={errStyle} className="error-field">{errors.school}</p>}
            </div>
          </div>

          <div className="enroll__row">
            <div className="enroll__group">
              <label className="enroll__label">Grade / Standard *</label>
              <select name="grade" value={formData.grade}
                onChange={handleChange} className="enroll__input enroll__select">
                <option value="">Select grade...</option>
                <option value="6">Grade 6</option>
                <option value="7">Grade 7</option>
                <option value="8">Grade 8</option>
                <option value="9">Grade 9</option>
              </select>
              {errors.grade && <p style={errStyle} className="error-field">{errors.grade}</p>}
            </div>
            <div className="enroll__group">
              <label className="enroll__label">Which Phase to Start</label>
              <select name="phase" value={formData.phase}
                onChange={handleChange} className="enroll__input enroll__select">
                <option value="phase1">Phase 1 — Electrical & Sensors </option>
                <option value="phase2">Phase 2 — Embedded Systems & IoT </option>
                <option value="phase3">Phase 3 — Robotics & Drones </option>
                <option value="full">Full 12-Month Programme </option>
              </select>
            </div>
          </div>

          <div className="enroll__group enroll__group--full">
            <label className="enroll__label">Any Questions or Requirements</label>
            <textarea name="questions" value={formData.questions} onChange={handleChange}
              placeholder="Prior experience, preferred timings, or any questions..."
              className="enroll__input enroll__textarea" />
          </div>

          <div className="enroll__group enroll__group--full">
            <label className="enroll__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="enroll__input enroll__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle} className="error-field">{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="enroll__input" style={{ marginTop: '8px' }} />
            )}
          </div>

          <button className="enroll__submit" onClick={handleSubmit}>
            Submit Enrollment Request →
          </button>
        </div>
      </div>
    </div>
  );
}

export default EnrollForm;